module.exports = "/next-static/_next/static/images/block_image_giveaways-f781b0339dae5773657d8f49d3d5b345.png";